import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, roles }) {
    const { user } = useAuth();
    const location = useLocation();

    if (user === null) {
        return (
            <div className="min-h-screen flex items-center justify-center">
                <div className="prc-label-overline" data-testid="auth-loading">
                    認証確認中…
                </div>
            </div>
        );
    }
    if (!user) return <Navigate to="/login" state={{ from: location }} replace />;

    if (roles && roles.length && !roles.includes(user.role) && user.role !== "super_admin") {
        return (
            <div className="min-h-screen flex items-center justify-center p-6">
                <div className="prc-card p-6 max-w-md text-center" data-testid="forbidden">
                    <p className="prc-label-overline mb-2">アクセス拒否</p>
                    <h2 className="text-xl font-semibold">このページへのアクセス権限がありません</h2>
                </div>
            </div>
        );
    }
    return children;
}
